import { apiService } from './api';
import { Item, ApiResponse } from '../types';

export const itemService = {
  async getItems(
    page: number = 1,
    perPage: number = 20,
    search?: string,
    filters?: {
      category?: string;
      stock_status?: 'in_stock' | 'running_low' | 'out_of_stock';
      min_price?: number;
      max_price?: number;
      sort_by?: 'name' | 'brand' | 'price' | 'quantity' | 'created_at';
      sort_order?: 'asc' | 'desc';
    }
  ): Promise<ApiResponse<{ items: Item[]; pagination: any }>> {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
    });
    if (search) {
      params.append('q', search);
    }
    if (filters) {
      if (filters.category) {
        params.append('category', filters.category);
      }
      if (filters.stock_status) {
        params.append('stock_status', filters.stock_status);
      }
      if (filters.min_price !== undefined) {
        params.append('min_price', filters.min_price.toString());
      }
      if (filters.max_price !== undefined) {
        params.append('max_price', filters.max_price.toString());
      }
      if (filters.sort_by) {
        params.append('sort_by', filters.sort_by);
      }
      if (filters.sort_order) {
        params.append('sort_order', filters.sort_order);
      }
    }
    return apiService.get(`/api/items?${params.toString()}`);
  },

  async getItem(id: number): Promise<ApiResponse<Item>> {
    return apiService.get(`/api/items/${id}`);
  },

  async createItem(data: {
    name: string;
    brand: string;
    size?: string;
    standard_price: number;
    selling_price?: number;
    quantity: number;
  }): Promise<ApiResponse<Item>> {
    return apiService.post('/api/items', data);
  },

  async updateItem(id: number, data: {
    name?: string;
    brand?: string;
    size?: string;
    standard_price?: number;
    selling_price?: number;
    quantity?: number;
  }): Promise<ApiResponse<Item>> {
    return apiService.put(`/api/items/${id}`, data);
  },

  async deleteItem(id: number): Promise<ApiResponse> {
    return apiService.delete(`/api/items/${id}`);
  },

  async searchItems(query: string): Promise<ApiResponse<Item[]>> {
    return apiService.get(`/api/items/search?q=${encodeURIComponent(query)}`);
  },

  async getLowStockItems(): Promise<ApiResponse<Item[]>> {
    return apiService.get('/api/items/low-stock');
  },

  async getOutOfStockItems(): Promise<ApiResponse<Item[]>> {
    return apiService.get('/api/items/out-of-stock');
  },
};

